module.exports = __webpack_public_path__ + "static/media/noticias-selected.abf15a71.svg";